import LayoutComponent from "src/components/user/layout-component";
import PaymentContainer from "src/containers/user/payment-container/payment-container";

function PaymentPage() {
  return (
    <LayoutComponent showLogo={true}>
      <div className="w-full h-screen mobile:h-full mobile:py-24 px-16 mobile:px-1.5 items-center justify-center bg-zinc-50">
        <PaymentContainer />
      </div>
    </LayoutComponent>
  );
}

export default PaymentPage;
